@if (isLink(item()) && isHighlighted(item())) {

<a [routerLink]="$any(item()).route"
  [routerLinkActiveOptions]="$any(item()).routerLinkActiveOptions || { exact: false }"
  routerLinkActive="active-highlighted"
  class="flex flex-col items-center -mt-6">
  <div class="relative flex items-center justify-center w-14 h-14 rounded-full bg-pmdf-danger shadow-pmdf-card shadow-pmdf-danger/40">
    <mat-icon class="icon-lg text-pmdf-base-primary" aria-hidden="false"
      [matBadge]="badgeHidden($any(item())) ? '' : badgeValue($any(item()))"
      [matBadgeColor]="'warn'" [matBadgeSize]="'small'"
      [matBadgeHidden]="badgeHidden($any(item()))">
      {{ $any(item()).icon }}
    </mat-icon>
    @if (!badgeHidden($any(item()))) {
      <span class="absolute -top-0.5 -right-0.5 flex h-3 w-3">
        <span class="absolute inline-flex h-full w-full animate-ping rounded-full bg-pmdf-danger opacity-75"></span>
        <span class="relative inline-flex h-3 w-3 rounded-full bg-pmdf-danger"></span>
      </span>
    }
  </div>
  <span class="truncate text-sm font-normal text-pmdf-base-secondary my-1">{{ item().label }}</span>
</a>

} @else if (isLink(item())) {

<a [routerLink]="$any(item()).route"
  [routerLinkActiveOptions]="$any(item()).routerLinkActiveOptions || { exact: false }"
  routerLinkActive="active"
  class="nav-item flex flex-col items-center gap-0.5 py-1">
  @if ($any(item()).svgIcon) {
    <mat-icon [svgIcon]="$any(item()).svgIcon" class="nav-svg-icon icon-lg font-light" aria-hidden="false"
      [matBadge]="badgeHidden($any(item())) ? '' : badgeValue($any(item()))"
      [matBadgeColor]="'warn'" [matBadgeSize]="'small'"
      [matBadgeHidden]="badgeHidden($any(item()))">
    </mat-icon>
  } @else if ($any(item()).icon) {
    <mat-icon class="icon-lg text-pmdf-base-secondary font-light" aria-hidden="false"
      [matBadge]="badgeHidden($any(item())) ? '' : badgeValue($any(item()))"
      [matBadgeColor]="'warn'" [matBadgeSize]="'small'"
      [matBadgeHidden]="badgeHidden($any(item()))">
      {{ $any(item()).icon }}
    </mat-icon>
  }
  <span class="truncate text-xs font-light text-pmdf-base-secondary mt-1">{{ item().label }}</span>
</a>

} @else if (isDropdown(item())) {

<a class="nav-item flex flex-col items-center gap-0.5 py-1" [matMenuTriggerFor]="dropdownMenu">
  @if ($any(item()).icon) {
    <mat-icon class="icon-lg text-pmdf-base-secondary font-light">{{ $any(item()).icon }}</mat-icon>
  }
  <span class="truncate text-xs font-light text-pmdf-base-secondary mt-1">{{ item().label }}</span>
</a>
<mat-menu #dropdownMenu="matMenu">
  @for (child of $any(item()).children; track child.label) {
    @if (isLink(child)) {
      <a mat-menu-item [routerLink]="child.route">
        @if (child.icon) {
          <mat-icon class="icon-lg">{{ child.icon }}</mat-icon>
        }
        <span class="text-xs font-light text-pmdf-base-secondary mt-1">{{ child.label }}</span>
      </a>
    }
  }
</mat-menu>

} @else if (isAction(item())) {

<button type="button" (click)="onAction()"
  class="nav-item flex flex-col items-center gap-0.5 py-1">
  @if ($any(item()).icon) {
    <mat-icon class="icon-lg text-pmdf-base-secondary font-light">{{ $any(item()).icon }}</mat-icon>
  }
  <span class="truncate text-xs font-light text-pmdf-base-secondary mt-1">{{ item().label }}</span>
</button>

}
